import { render, staticRenderFns } from "./HeroSteps.vue?vue&type=template&id=36085f45&"
import script from "./HeroSteps.vue?vue&type=script&lang=js&"
export * from "./HeroSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports